import React from 'react'
import 'styles/searchByBlock.scss'
import DeviceId from 'utils/detectDevice'

const Link = ({ link, anchorTag }) => {
  const title =
    anchorTag === 'Malayalam' ? 'Kerala Matrimony' : `${anchorTag} Matrimony`
  return (
    <a href={link} title={title} target="_blank" rel="noopener noreferrer">
      {anchorTag}
    </a>
  )
}

const TypeWiseBlock = ({ blockName, arrLinks }) => {
  return (
    <div className="popular_sites col-sm-4">
      <div className="bottom_nav_head">{blockName}</div>
      <ul className="nav">
        {arrLinks
          .filter(value => value.subtype === 'link')
          .map(link => (
            <li key={link.id}>
              <Link link={link.link} anchorTag={link.anchortag} />
            </li>
          ))}
      </ul>
      {arrLinks
        .filter(value => value.subtype === 'morelink')
        .map(link => (
          <div key={link.id}>
            <a
              href={`${link.link}`}
              className="link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.anchortag}
            </a>
            <span className="rightArrow" />
          </div>
        ))}
    </div>
  )
}

const RenderLinksBlock = ({ linksData }) =>
  Object.keys(linksData).map(key => {
    const arrData = linksData[key].sort((a, b) => a.id - b.id)

    return (
      <>
        {key === '4' && DeviceId.isDesktop() && (
          <div className="popular_sites col-sm-4" />
        )}
        <TypeWiseBlock
          blockName={arrData[0]['type']}
          arrLinks={arrData}
          key={Math.random()}
        />
      </>
    )
  })

function SearchByBlock(props) {
  const reOrderedData = (props.searchByData || []).reduce(
    (orderByData, value) => ({
      ...orderByData,
      [value.data.orderby]: [
        ...(orderByData[value.data.orderby] || []),
        value.data,
      ],
    }),
    {}
  )

  const containerText = props.containerText
    ? props.containerText
    : 'Search by Popular Matchmaking Sites'

  return (
    <div className="container">
      <h2 className="text-center find_someone">{containerText}</h2>
      <div className="row">
        <RenderLinksBlock linksData={reOrderedData} />
      </div>
    </div>
  )
}

export default SearchByBlock
